"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _majorType = require("@/api/project/majorType");
var _expert = require("@/api/expert/expert");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "姓名关键字"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "项目名称",
        prop: "matchName",
        isShow: true,
        width: "200"
      }, {
        name: "项目组别",
        prop: "groupName",
        isShow: true,
        width: "100"
      }, {
        name: "项目阶段",
        prop: "stageName",
        isShow: true,
        width: "100"
      }, {
        name: "作品/课程名称",
        prop: "worksName",
        isShow: true,
        width: "300"
      }, {
        name: "姓名",
        prop: "userName",
        isShow: true,
        width: "100"
      }, {
        name: "分数",
        prop: "totalScore",
        isShow: true,
        width: "200"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      checkBoxs: [],
      options: [{
        name: "审核打分",
        class: "edit",
        option: "auditScore",
        span: 3,
        field: {
          name: "status",
          value: 0
        }
      }, {
        name: "查看",
        class: "editor",
        option: "detail",
        span: 24,
        field: {
          name: "status",
          value: 1
        }
      }]
    };
  },
  methods: {
    // 审核打分
    auditScore: function auditScore(e) {
      console.log(e, "11");
      this.$router.push({
        path: "/gradeScore/gradeScoreX",
        query: {
          workId: e.worksId,
          id: e.id,
          backId: this.$route.query.id
        }
      });
    },
    //查看打分详情
    detail: function detail(row) {
      this.$router.push({
        path: "/grade/viewWorks",
        query: {
          worksId: row.worksId
        }
      });
    },
    // 获取审核作品列表
    getAuditWorkList: function getAuditWorkList() {
      var _this = this;
      (0, _expert.auditByExpertId)({
        groupId: "",
        matchId: this.$route.query.id,
        stageId: "",
        name: this.queryValue,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize
      }).then(function (res) {
        var data = res.data;
        _this.listData = data.list;
        _this.totalData = data.total;
      });
    },
    // 模糊搜索
    search: function search(e) {
      this.queryValue = e.queryValue;
      this.getAuditWorkList();
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this2 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this2.checkBoxs.push(item.id);
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getAuditWorkList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageNumber = 1;
      this.page.pageSize = e;
      this.getAuditWorkList();
    }
  },
  created: function created() {
    this.getAuditWorkList();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};